import { RitualActionTypes } from './constants';

export type RitualActionType = {
    type:
        | RitualActionTypes.API_RESPONSE_SUCCESS
        | RitualActionTypes.API_RESPONSE_ERROR
        | RitualActionTypes.GET_RITUALS
        | RitualActionTypes.GET_RITUAL_BY_ID
        | RitualActionTypes.ADD_RITUAL
        | RitualActionTypes.UPDATE_RITUAL
        | RitualActionTypes.DELETE_RITUAL
        | RitualActionTypes.TAG_SERVICE_TO_RITUALS
        | RitualActionTypes.TAG_PRODUCT_TO_RITUALS
        | RitualActionTypes.ASSIGN_RITUAL_TO_POOJARI
        | RitualActionTypes.GET_RITUALS_BY_POOJARI
        | RitualActionTypes.GET_POOJARIS_BY_RITUAL
        | RitualActionTypes.UPDATE_POOJARI_RITUAL
        | RitualActionTypes.REMOVE_RITUAL_FROM_POOJARI
        | RitualActionTypes.RESET;
    payload: {} | string;
};

// common success
export const ritualApiResponseSuccess = (actionType: string, data: any): RitualActionType => ({
    type: RitualActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// common error
export const ritualApiResponseError = (actionType: string, error: string): RitualActionType => ({
    type: RitualActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// Get rituals
export const getRituals = (params?: any): RitualActionType => ({
    type: RitualActionTypes.GET_RITUALS,
    payload: params,
});

// Get ritual by ID
export const getRitualById = (ritualId: string): RitualActionType => ({
    type: RitualActionTypes.GET_RITUAL_BY_ID,
    payload: { ritualId },
});

// Add ritual
export const addRitual = (ritualData: any): RitualActionType => ({
    type: RitualActionTypes.ADD_RITUAL,
    payload: ritualData,
});

// Update ritual
export const updateRitual = (ritualId: string, ritualData: any): RitualActionType => ({
    type: RitualActionTypes.UPDATE_RITUAL,
    payload: { ritualId, ritualData },
});

// Delete ritual
export const deleteRitual = (ritualId: string): RitualActionType => ({
    type: RitualActionTypes.DELETE_RITUAL,
    payload: { ritualId },
});

// Tag service to rituals
export const tagServiceToRituals = (params: { ritualIds: number[]; serviceId: number }): RitualActionType => ({
    type: RitualActionTypes.TAG_SERVICE_TO_RITUALS,
    payload: params,
});

// Tag product to rituals
export const tagProductToRituals = (params: { ritualIds: number[]; productId: string }): RitualActionType => ({
    type: RitualActionTypes.TAG_PRODUCT_TO_RITUALS,
    payload: params,
});

// Assign ritual to poojari
export const assignRitualToPoojari = (params: {
    poojariId: number;
    ritualId: number;
    price: number;
    notes?: string;
    duration?: string;
}): RitualActionType => ({
    type: RitualActionTypes.ASSIGN_RITUAL_TO_POOJARI,
    payload: params,
});

// Get rituals by poojari
export const getRitualsByPoojari = (poojariId: string, params?: any): RitualActionType => ({
    type: RitualActionTypes.GET_RITUALS_BY_POOJARI,
    payload: { poojariId, ...params },
});

// Get poojaris by ritual
export const getPoojarisByRitual = (ritualId: string, params?: any): RitualActionType => ({
    type: RitualActionTypes.GET_POOJARIS_BY_RITUAL,
    payload: { ritualId, ...params },
});

// Update poojari ritual
export const updatePoojariRitual = (poojariRitualId: string, updateData: any): RitualActionType => ({
    type: RitualActionTypes.UPDATE_POOJARI_RITUAL,
    payload: { poojariRitualId, updateData },
});

// Remove ritual from poojari
export const removeRitualFromPoojari = (poojariId: string, ritualId: string): RitualActionType => ({
    type: RitualActionTypes.REMOVE_RITUAL_FROM_POOJARI,
    payload: { poojariId, ritualId },
});

// Reset state
export const resetRituals = (): RitualActionType => ({
    type: RitualActionTypes.RESET,
    payload: {},
});
